"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.height = void 0;
const layout_1 = require("@carbon/layout");
exports.height = {
    timelineHeader: (0, layout_1.rem)(55),
    singleLayerHeader: (0, layout_1.rem)(45),
    singleLayerProperty: (0, layout_1.rem)(28),
};
